module.exports = __webpack_public_path__ + "static/media/p.b0646266.png";